import React, { useState } from "react";
import { useAppSelector } from "../../Redux/hooks";
import { Button, CircularProgress } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CreateResponseModal from "../Responses/CreateResponseModal";
import { platformAdminPermissions } from "../../utils/roles";
import { useNavigate, useParams } from "react-router-dom";
import FinishScreeningModal from "./FinishScreeningModal";
import { toastMessage } from "../../utils/toast";
import { canEditScreeningByEligibility } from "../../utils/screeningEditEligibility";

const ScreenerHeaderDetails = ({
  type,
  isLocked,
}: {
  type: string;
  isLocked?: boolean;
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showFinishModal, setShowFinishModal] = useState(false);
  const isResponseSubmitting = useAppSelector(
    (state) => state.response.fieldSubmitting
  );

  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );

  // Edit capability requires both the permission AND a non-locked participant
  // (deactivated/redacted participants are read-only).
  const [hasEditPermission] = useState(
    platformPermissions.includes(platformAdminPermissions.managePlatform) ||
      false
  );
  const canEdit = hasEditPermission && !isLocked;

  const screeningBtn = useAppSelector((state) => state.response.screeningBtn);
  const selectedForm = useAppSelector((state) => state.response.selectedForm);
  const screeningAttemptId = useAppSelector(
    (state) => state.response.screeningAttemptId
  );

  const isEditable = useAppSelector((state) => state.response.editable);

  const canComplete =
    isEditable &&
    (screeningBtn === "compare" || screeningBtn === "complete") &&
    canEdit;

  const eligibilityStatus = useAppSelector(
    (state) => state.response.eligibilityStatus
  );

  const canEditByEligibility = canEditScreeningByEligibility(eligibilityStatus);
  const showFillScreener =
    !screeningAttemptId && canEdit && canEditByEligibility;
  const showEditResponses =
    !!screeningAttemptId &&
    !isEditable &&
    canEdit &&
    canEditByEligibility;

  const navigate = useNavigate();
  const { participantId } = useParams();

  const navigateToCompare = () => {
    navigate(
      `/app/participants/${participantId}/responses/${selectedForm?.id}/compare?formName=${selectedForm?.name}`
    );
  };

  const handlePrint = () => {
    if (!selectedForm || !participantId) {
      toastMessage("warning", "Please select a form to print");
      return;
    }

    const params = new URLSearchParams({
      formId: selectedForm.id,
      formName: selectedForm.name || "",
      participantId: participantId,
      category: "screening",
      isRegistryParticipant: "true",
    });

    if (screeningAttemptId) {
      params.append("screeningAttemptId", screeningAttemptId);
    }

    const printUrl = `/print/form-response?${params.toString()}`;
    window.open(printUrl, "_blank");
  };

  const openCreateModal = () => {
    setShowModal(true);
  };

  const closeCreateModal = () => {
    setShowModal(false);
  };

  const openFinishModal = () => {
    setShowFinishModal(true);
  };

  const closeFinishModal = () => {
    setShowFinishModal(false);
  };

  return (
    <>
      {isResponseSubmitting && <CircularProgress color="primary" size={24} />}
      {type === "screening" && (
        <>
          {selectedForm && (
            <Button
              variant="outlined"
              onClick={handlePrint}
              startIcon={<PrintIcon />}
            >
              Print
            </Button>
          )}
          {screeningBtn === "compare" && (
            <Button variant="outlined" onClick={() => navigateToCompare()}>
              Compare responses
            </Button>
          )}
          {canComplete && (
            <Button variant="contained" onClick={openFinishModal}>
              Save and Complete
            </Button>
          )}
          {(showFillScreener || showEditResponses) && (
            <Button variant="outlined" onClick={() => openCreateModal()}>
              {showFillScreener ? "Fill Screener" : "Edit responses"}
            </Button>
          )}
        </>
      )}
      {type === "screening" && (
        <>
          {/* {eligibilityStatus === "unverified" && screeningAttemptId && (
            <Button variant="contained" onClick={() => setShowModal(true)}>
              Finish Review
            </Button>
          )}
          {eligibilityStatus === "decide_later" && (
            <Button variant="contained" onClick={() => setShowModal(true)}>
              Change Status
            </Button>
          )} */}
        </>
      )}

      {showModal && (
        <CreateResponseModal
          showModal={showModal}
          closeModal={closeCreateModal}
        />
      )}

      {showFinishModal && (
        <FinishScreeningModal
          showModal={showFinishModal}
          closeModal={closeFinishModal}
        />
      )}
    </>
  );
};

export default ScreenerHeaderDetails;
